import './App.scss';

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Exito from './pages/Exito';
import FinanciarWizard from './pages/financiarWizard/FinanciarWizard';
import FormContacto from './pages/financiarWizard/FormContacto';
import FormCredito from './pages/financiarWizard/FormCredito';
import Simulacion from './pages/financiarWizard/Simulacion';
import Home from './pages/Home';
import NoPage from './pages/NoPage';
import ConDetalle from './pages/refinanciarWizard/ConDetalle';
import InfoCredito from './pages/refinanciarWizard/InfoCredito';
import RefinanciarWizard from './pages/refinanciarWizard/RefinanciarWizard';
import SinDetalle from './pages/refinanciarWizard/SinDetalle';
import SuccessfulApplication from './pages/SuccessfulApplication';
import ValidarRenta from './pages/ValidarRenta/ValidarRenta';

import { TenantProvider } from './context/TenantContext';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import TenantEffects from './components/tenantEffect/TenantEffects';

const App = () => {
  return (
    <FeatureFlagsProvider>
      <TenantProvider>
        <TenantEffects />

        <div className="app-container">
          <Helmet>
            <script src="//cdn.muicss.com/mui-0.10.3/js/mui.min.js" />
          </Helmet>

          <div className="app-content">
            <BrowserRouter>
              <Routes>
                <Route index element={<Home />} />
                <Route path="credito-automotriz-simple" element={<FinanciarWizard />} />
                <Route path="refinancia-tu-credito" element={<RefinanciarWizard />} />

                <Route path="financiar" element={<FormContacto />} />
                <Route path="refinanciar" element={<FormContacto />} />
                <Route path="formCredito" element={<FormCredito />} />
                <Route path="conDetalle" element={<ConDetalle />} />
                <Route path="sinDetalle" element={<SinDetalle />} />
                <Route path="simulacion" element={<Simulacion />} />
                <Route path="validarRenta" element={<ValidarRenta />} />
                <Route path="infoCredito" element={<InfoCredito />} />
                <Route path="credito-automotriz-simple/solicitud-exitosa" element={<Exito />} />
                <Route
                  path="refinancia-tu-credito/solicitud-exitosa"
                  element={<SuccessfulApplication />}
                />
                <Route path="*" element={<NoPage />} />
              </Routes>
            </BrowserRouter>
          </div>
        </div>
      </TenantProvider>
    </FeatureFlagsProvider>
  );
};

export default App;
